<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/005_Preface#fm-1"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/006_Introduction#fm-2">Introduction</a></p>
<p class="toc-chap"><a href="#/007_Chapter01#ch-1">1. Discipleship as Transformation of Self</a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample">2. Discipleship before the Reformation</span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample">3. Post-Reformation Discipleship</span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample">4. Discipleship under Threat</span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample">5. Shaping a New Vision</span></p>
<p class="toc-chap"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample">6. A Critical Analysis of the Two Visions</span></p>
<p class="toc-chap"><span href="#/013_Chapter07#ch-7" title="Link target outside of Sample">7. Discipleship in Churches</span></p>
<p class="toc-chap"><span href="#/014_Chapter08#ch-8" title="Link target outside of Sample">8. Imitating Saints</span></p>
<p class="toc-bm"><span href="#/015_Suggested_Reading#bm-1" title="Link target outside of Sample"><em>Suggested Reading</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Contents.vue?71091529